import React, { useState, useEffect } from "react";
import { format } from "date-fns";
import { CalendarIcon, ChevronLeft, ChevronRight, X, Plus } from "lucide-react"; // import icons you're using
import { Input } from "../components/ui/input";
import { Select, DatePicker } from "antd";
import moment from "moment";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { AddBankAccount, EditBankAccount, GetBankList } from "../API  Functions/ProfileFunctions";
import { useTranslation } from "react-i18next";
import LoadingSpinner from "../components/Loading";


const { Option } = Select;



const AddBankAccountModal = ({
    isOpen,
    setIsDialogOpen,
    formData,
    setFormData,
    handleSubmit,
    resetForm,
    editingAccount,
    onSubmit,
    isPrimary,
    setIsPrimary,
    accounts
}) => {

    const { t, i18n } = useTranslation();

    const [showCalendar, setShowCalendar] = useState(false);
    const [balanceDate, setBalanceDate] = useState(null);
    const [loading, setLoading] = useState(false);
    const companyId = useSelector(
        (state) => state?.login?.user?.result?.company_id
    );

    const [availableBanks, setAvailableBanks] = useState([]);
    const [loadingBanks, setLoadingBanks] = useState(true);
    const [originalData, setOriginalData] = useState(null);
    const [touchedFields, setTouchedFields] = useState({});

    // const SWIFT_REGEX = /^[A-Z]{4}EG[A-Z0-9]{2}([A-Z0-9]{3})?$/;


    const isOnlyPrimary = accounts.filter((a) => a.isActive).length === 1 && editingAccount?.isActive;




    useEffect(() => {
        const fetchBanks = async () => {
            const banks = await GetBankList();
            setAvailableBanks(banks);
            setLoadingBanks(false);
        };
        fetchBanks();
    }, []);


    useEffect(() => {
        if (editingAccount) {
            const initialForm = {
                accountNumber: editingAccount.accountNumber,
                accountName: editingAccount.accountName,
                bankName: editingAccount.bankName,
                bankId: editingAccount.bankId,
                branchName: editingAccount.branchName,
                swiftCode: editingAccount.swiftCode,
                iban: editingAccount.iban,
                balanceDate: editingAccount.balanceDate
                    ? dayjs(editingAccount.balanceDate)
                    : null,
                balance: editingAccount.balance.toString(),
                isActive: editingAccount.isActive,
            };

            setFormData(initialForm);
            setOriginalData(initialForm);
        } else {
            resetForm();
            setOriginalData(null);
        }
    }, [editingAccount]);

    const handleDateChange = (date) => {
        setFormData({ ...formData, balanceDate: date });
    };

    const isFormChanged = () => {
        if (!originalData) return true; // always enable for new account

        const keys = Object.keys(originalData);
        for (let key of keys) {
            const current = formData[key];
            const original = originalData[key];

            // Compare dates properly
            if (dayjs.isDayjs(current) && dayjs.isDayjs(original)) {
                if (!current.isSame(original, "day")) return true;
            } else if (current !== original) {
                return true;
            }
        }
        return false; // no changes found
    };


    const handleFormSubmit = async (e) => {
        e.preventDefault();


        const requiredFields = [
            "accountNumber",
            "accountName",
            "bankName",
            // "bankId",
            "branchName",
            "swiftCode",
            "iban"
        ];

        const newTouched = {};
        let isValid = true;

        console.log("cdvbsbsdbvsd", formData);


        requiredFields.forEach((field) => {
            if (!formData[field]) {
                newTouched[field] = true;
                isValid = false;
            }
        });

        // if (formData.swiftCode && !SWIFT_REGEX.test(formData.swiftCode)) {
        //     newTouched.swiftCode = true;
        //     isValid = false;
        //     toast.error(t("Invalid SWIFT Code format."));
        //     return;
        // }


        if (!isValid) {
            setTouchedFields((prev) => ({ ...prev, ...newTouched }));
            toast.error(t("Please fill in all required fields."));
            return;
        }

        const {
            accountNumber,
            accountName,
            bankName,
            bankId,
            branchName,
            swiftCode,
            iban,
            balanceDate,
            balance,
            isActive,
        } = formData;

        if (
            !accountNumber ||
            !accountName ||
            !bankName ||
            // !bankId ||
            !branchName ||
            !swiftCode ||
            !iban
        ) {
            toast.error(t("Please fill in all required fields."));
            return;
        }

        setLoading(true);

        const payloadData = {
            account_number: accountNumber,
            account_name: accountName,
            bank_id: bankId,
            bank_name: bankName,
            branch_name: branchName,
            swift_code: swiftCode,
            iban: iban,
            balance_as_on: balanceDate ? balanceDate.format("YYYY-MM-DD") : null,
            balance: balance ? Number(balance) : null,
            // balance_as_on: balanceDate ? balanceDate.format("YYYY-MM-DD") : null,
            // balance: Number(balance),
            is_active: isActive,

        };

        // console.log("EDITING ACCOUNT DATA", editingAccount);


        if (editingAccount?.id) {
            // Include account_id for editing
            payloadData.account_id = editingAccount.id;
        }

        const payload = {
            lang: "en_US",
            company_id: companyId,
            accounts: [payloadData],
        };

        try {
            let response;

            if (editingAccount) {
                response = await EditBankAccount(payload);
            } else {
                response = await AddBankAccount(payload);
            }

            const status = response?.data?.result?.status;

            if (status === 200) {
                toast.success(editingAccount ? (t("Bank account updated successfully.")) : (t("Bank account added successfully.")));
                setIsDialogOpen(false);
                resetForm();

                if (typeof onSubmit === "function") {
                    onSubmit(); // Notify parent to refresh
                }
            } else if (status === 400) {
                toast.error(t("This account number is already registered."));
            } else {
                toast.error(response?.data?.result?.message || "Something went wrong.");
            }
        } catch (error) {
            console.error("API error:", error);
            toast.error(error.message || "An error occurred.");
        } finally {
            setLoading(false);
        }
    };

    if (!isOpen) return null;

    return (
        <>
            {loading && <LoadingSpinner />}
            <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
                <div className="bg-card border border-border rounded-lg shadow-lg max-w-2xl w-[50%] max-h-[90vh] overflow-y-auto">
                    <div className="flex items-center justify-between p-6 border-b border-border">
                        <h2 className="text-2xl font-semibold text-card-foreground">
                            {editingAccount ? (t("Edit Bank Account")) : (t("Add New Bank Account"))}
                        </h2>
                        <button
                            onClick={() => {
                                setIsDialogOpen(false);
                                setTouchedFields({})
                                resetForm();
                            }}
                            className="text-muted-foreground hover:text-foreground transition-colors"
                        >
                            <X className="h-5 w-5" />
                        </button>
                    </div>

                    <form onSubmit={handleFormSubmit} className="p-6 space-y-6">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="space-y-2">
                                <label htmlFor="accountNumber" className="text-sm font-medium text-card-foreground">
                                    {t("Account Number")} *
                                </label>
                                <Input
                                    id="accountNumber"
                                    type="text"
                                    maxLength={25}
                                    placeholder={t("Enter account number")}
                                    value={formData.accountNumber}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/\D/g, ""); // allow only digits
                                        if (value.length <= 25) {
                                            setFormData({ ...formData, accountNumber: value });
                                            setTouchedFields({ ...touchedFields, accountNumber: true });
                                        }
                                    }}
                                    className={`w-full px-3 py-2 bg-background border rounded-md text-foreground placeholder:text-muted-foreground
    ${touchedFields.accountNumber && !formData.accountNumber ? "border-red" : "border-input"}
`}
                                // className="w-full px-3 py-2 bg-background border border-input rounded-md text-foreground placeholder:text-muted-foreground"
                                />
                            </div>

                            <div className="space-y-2">
                                <label htmlFor="accountName" className="text-sm font-medium text-card-foreground">
                                    {t("Account Holder Name")} *
                                </label>
                                <Input
                                    id="accountName"
                                    type="text"
                                    placeholder={t("Enter account holder name")}
                                    value={formData.accountName}
                                    onChange={(e) => {
                                        const value = e.target.value.replace(/[^a-zA-Z0-9\u0600-\u06FF\s]/g, ""); // no special chars or decimal
                                        setFormData({ ...formData, accountName: value });
                                        setTouchedFields({ ...touchedFields, accountName: true });

                                    }}
                                    className={`w-full px-3 py-2 bg-background border rounded-md text-foreground placeholder:text-muted-foreground
    ${touchedFields.accountName && !formData.accountName ? "border-red" : "border-input"}
`}
                                // className="w-full px-3 py-2 bg-background border border-input rounded-md text-foreground placeholder:text-muted-foreground"
                                />
                            </div>

                            <div className="space-y-2">
                                <label htmlFor="bankName" className="text-sm font-medium text-card-foreground">
                                    {t("Bank Name")} *
                                </label>
                                <Select
                                    id="bankName"
                                    // value={formData.bankName || undefined}
                                    value={formData.bankName || undefined}

                                    // onChange={(value) => setFormData({ ...formData, bankName: value });}
                                    // onChange={(value) => {
                                    //     setFormData({ ...formData, bankName: value });
                                    //     setFormData({ ...formData, bankId: value, });
                                    //     setTouchedFields({ ...touchedFields, bankId: true });
                                    //     // setTouchedFields({ ...touchedFields, bankName: true });
                                    // }}
                                    onChange={(value) => {
                                        const selectedBank = availableBanks.find(
                                            (bank) => bank.bank_id === value || bank.id === value
                                        );
                                        setFormData({
                                            ...formData,
                                            bankId: value,
                                            bankName: selectedBank ? selectedBank.bank_name || selectedBank.name : "",
                                        });
                                        setTouchedFields({ ...touchedFields, bankName: true });
                                    }}
                                    placeholder={t("Select a bank")}
                                    className={`w-full ${touchedFields.bankId && !formData.bankId ? "border border-red" : ""}`}
                                    // className="w-full"
                                    optionFilterProp="children"
                                    showSearch
                                    allowClear
                                    loading={loadingBanks}
                                    disabled={editingAccount}
                                >
                                    {availableBanks.map((bank) => (
                                        <Option key={bank.bank_id || bank.id} value={bank.bank_id || bank.id}>
                                            {bank.bank_name || bank.name}
                                        </Option>
                                    ))}
                                </Select>
                            </div>

                            <div className="space-y-2">
                                <label htmlFor="branchName" className="text-sm font-medium text-card-foreground">
                                    {t("Branch Name")} *
                                </label>
                                <Input
                                    id="branchName"
                                    type="text"
                                    placeholder={t("Enter Branch Name")}
                                    value={formData.branchName}
                                    onChange={(e) => {
                                        // Allow only letters, numbers, and spaces
                                        const sanitized = e.target.value
                                            .replace(/[^A-Za-z0-9\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF ]/g, "") // remove special chars & decimals // remove special chars & decimals
                                            .replace(/\s+/g, " ") // replace multiple spaces with one
                                            .trimStart(); // prevent leading spaces

                                        setFormData({ ...formData, branchName: sanitized });
                                        setTouchedFields({ ...touchedFields, branchName: true });

                                    }}
                                    // className="w-full px-3 py-2 bg-background border border-input rounded-md text-foreground placeholder:text-muted-foreground"
                                    inputMode="text"
                                    autoComplete="off"
                                    className={`w-full px-3 py-2 bg-background border rounded-md text-foreground placeholder:text-muted-foreground
    ${touchedFields.branchName && !formData.branchName ? "border-red" : "border-input"}
`}
                                />
                            </div>

                            {/* <div className="space-y-2">
                                <label htmlFor="swiftCode" className="text-sm font-medium text-card-foreground">
                                    {t("SWIFT Code")} *
                                </label>
                                <Input
                                    id="swiftCode"
                                    type="text"
                                    placeholder="NBEGEGCXXXX"
                                    value={formData.swiftCode}
                                    onChange={(e) => {
                                        const value = e.target.value.toUpperCase();
                                        const sanitized = value.replace(/[^A-Z0-9]/g, "");
                                        setFormData({ ...formData, swiftCode: sanitized });
                                        setTouchedFields({ ...touchedFields, swiftCode: true });
                                    }}
                                    inputMode="text"
                                    autoComplete="off"
                                    maxLength={11}
                                    className={`w-full px-3 py-2 bg-background border rounded-md text-foreground placeholder:text-muted-foreground
      ${touchedFields.swiftCode && !formData.swiftCode ? "border-red" : "border-input"}
    `}
                                />
                                {touchedFields.swiftCode && formData.swiftCode && !SWIFT_REGEX.test(formData.swiftCode) && (
                                    <p className="text-xs text-red">{t("Invalid SWIFT Code format")}</p>
                                )}
                            </div> */}

                            <div className="space-y-2">
                                <label htmlFor="swiftCode" className="text-sm font-medium text-card-foreground">
                                    {t("Swift Code")} *
                                </label>
                                <Input
                                    id="swiftCode"
                                    type="text"
                                    placeholder="SWIBNXXX0999"
                                    value={formData.swiftCode}
                                    onChange={(e) => {
                                        // Allow only uppercase letters and digits (A–Z, 0–9)
                                        const sanitized = e.target.value
                                            .replace(/[^A-Za-z0-9]/g, "") // strip anything not alphanumeric
                                            .toUpperCase();

                                        setFormData({ ...formData, swiftCode: sanitized });
                                        setTouchedFields({ ...touchedFields, swiftCode: true });

                                    }}
                                    // className="w-full px-3 py-2 bg-background border border-input rounded-md text-foreground placeholder:text-muted-foreground"
                                    inputMode="text" // enables A-Z + 0-9 on mobile keyboard
                                    autoComplete="off"
                                    maxLength={11}
                                    className={`w-full px-3 py-2 bg-background border rounded-md text-foreground placeholder:text-muted-foreground
    ${touchedFields.swiftCode && !formData.swiftCode ? "border-red" : "border-input"}
`}
                                />

                            </div>

                            <div className="space-y-2">
                                <label htmlFor="iban" className="text-sm font-medium text-card-foreground">
                                    IBAN *
                                </label>
                                <Input
                                    id="iban"
                                    type="text"
                                    placeholder={t("Enter IBAN")}
                                    value={formData.iban}
                                    onChange={(e) => {
                                        const sanitized = e.target.value
                                            .replace(/[^A-Za-z0-9]/g, "") // allow only alphanumeric
                                            .toUpperCase();

                                        setFormData({ ...formData, iban: sanitized });
                                        setTouchedFields({ ...touchedFields, iban: true });

                                    }}
                                    // className="w-full px-3 py-2 bg-background border border-input rounded-md text-foreground placeholder:text-muted-foreground"
                                    inputMode="text"
                                    autoComplete="off"
                                    maxLength={30}
                                    className={`w-full px-3 py-2 bg-background border rounded-md text-foreground placeholder:text-muted-foreground
    ${touchedFields.iban && !formData.iban ? "border-red" : "border-input"}
`}
                                />

                            </div>


                            <div className="space-y-2">
                                <label className="text-sm font-medium text-card-foreground">{t("Balance as on")} </label>
                                <DatePicker
                                    style={{ width: "100%" }}
                                    onChange={handleDateChange}
                                    placeholder={t("Select Date")}
                                    value={formData.balanceDate && dayjs(formData.balanceDate)}
                                    disabledDate={(current) =>
                                        current && current > moment().endOf("day")
                                    }
                                    disabled={!!editingAccount}  // ✅ Always disable in edit mode
                                    // disabled={editingAccount && !!formData.balanceDate} // disable only if there's a value
                                    // disabled={editingAccount}
                                    className="h-10"
                                />
                            </div>



                            <div className="space-y-2">
                                <label htmlFor="balance" className="text-sm font-medium text-card-foreground">
                                    {t("Balance")} (EGP)
                                </label>
                                <Input
                                    id="balance"
                                    type="text"
                                    placeholder={t("Enter balance")}
                                    value={formData.balance}
                                    onChange={(e) => {
                                        let value = e.target.value;

                                        // Only allow valid decimal numbers (max 2 decimal places)
                                        // Must start with a digit, not a dot
                                        const regex = /^(?:\d+(?:\.\d{0,2})?)?$/;

                                        if (value === "" || regex.test(value)) {
                                            setFormData({ ...formData, balance: value });
                                        }
                                    }}
                                    onBlur={(e) => {
                                        // Auto-prepend 0 if user entered .something (edge case)
                                        if (e.target.value.startsWith(".")) {
                                            setFormData({ ...formData, balance: `0${e.target.value}` });
                                        }
                                    }}
                                    className="w-full px-3 py-2 bg-background border border-input rounded-md text-foreground placeholder:text-muted-foreground"
                                    inputMode="decimal"
                                    autoComplete="off"
                                    disabled={editingAccount && !!formData.balance} // disable only if there's a value
                                    // disabled={editingAccount}
                                    maxLength={12}
                                />

                            </div>

                            {accounts.length > 0 && (
                                <div className="flex items-center space-x-2 pt-2">
                                    <input
                                        type="checkbox"
                                        id="makePrimary"
                                        checked={formData.isActive}
                                        onChange={(e) =>
                                            setFormData({ ...formData, isActive: e.target.checked })
                                        }
                                        disabled={isOnlyPrimary}
                                        className="h-4 w-4 text-primary border-gray-300 rounded focus:ring-primary"
                                    />
                                    <label htmlFor="makePrimary" className="text-sm text-foreground">
                                        {t("Make this account primary")}
                                    </label>
                                </div>
                            )}



                        </div>
                        <div className="flex justify-end gap-3 pt-4">
                            <button
                                type="button"
                                onClick={() => {
                                    setIsDialogOpen(false);
                                    setTouchedFields({})
                                    resetForm();
                                }}
                                className="px-4 py-2 border border-input bg-background rounded-md font-medium transition-colors"
                            >
                                {t("Cancel")}
                            </button>
                            <button
                                type="submit"
                                disabled={editingAccount && !isFormChanged()} //  Disable if editing and no changes
                                className={`px-4 py-2 rounded-md font-medium transition-colors
    ${editingAccount && !isFormChanged()
                                        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                                        : "bg-primary hover:bg-primary/90 text-primary-foreground"
                                    }`}
                            >
                                {editingAccount ? t("Update Account") : t("Add Account")}
                            </button>

                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default AddBankAccountModal;
